import { Stack } from "@eworkit/iris";
import React, { FC } from "react";
import { PublicProfileNewsCard } from "views/Clients/News/PublicProfileNewsCard";

import { PublicProfile, NewsItem } from "@/data/public-profiles";

interface PublicProfileNewsListProps {
  publicProfile: PublicProfile;
  news: NewsItem[];
  isPublic?: boolean;
}

export const PublicProfileNewsList: FC<PublicProfileNewsListProps> = ({ publicProfile, news, isPublic }) => {
  return (
    <Stack gap="sm">
      {news.map(n => (
        <PublicProfileNewsCard key={n.id} publicProfile={publicProfile} news={n} isPublic={isPublic} />
      ))}
    </Stack>
  );
};
